import { useMemo } from "react"
import { useForm } from "react-hook-form"

import { InstallationReferenceFilterState } from "entities/building-references/types/InstallationReferenceFilterState"
import { ProductSelectOption } from "entities/products/types/ProductSelectOption"

import { InstallationReferenceFilterViewModel } from "../InstallationReferenceFilterView"

interface UseInstallationReferenceViewModelArgs {
  defaultValues?: InstallationReferenceFilterState
  availableProductFilterOptions?: ProductSelectOption[] | null | undefined
}

const defaultInstallationReferenceFilterState: InstallationReferenceFilterState =
  {
    products: [],
    roomTypes: [],
    buildingTypes: []
  }

export function useInstallationReferenceFilterViewModel({
  defaultValues,
  availableProductFilterOptions
}: UseInstallationReferenceViewModelArgs): InstallationReferenceFilterViewModel {
  const form = useForm<InstallationReferenceFilterState>({
    defaultValues: defaultValues || defaultInstallationReferenceFilterState
  })

  const productFilterOptions: ProductSelectOption[] = useMemo(
    () =>
      availableProductFilterOptions?.sort((a, b) =>
        a.label > b.label ? 1 : -1
      ) || [],
    [availableProductFilterOptions]
  )

  return {
    form,
    productFilterOptions
  }
}
